


























import { defineComponent, ref, useRouter } from '@nuxtjs/composition-api';
import useLocalStorageCart from '@shared/composables/useLocalStorageCart';
import { BaseButton, BaseHeading, BaseImage, BaseModal } from '@shared/ui';
import { useUser } from '@unified-commerce/gpc-vue-storefront-shopify';

export default defineComponent({
  name: 'LogoutModal',
  components: {
    BaseModal,
    BaseImage,
    BaseHeading,
    BaseButton,
  },
  transition: 'fade',
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    logoutIconSrc: {
      type: String,
      default: '/icons/logout.svg',
    },
    logoutIconAlt: {
      type: String,
      default: 'Arrow pointing to the right with a circle surrounding it.',
    },
    headerTitleText: {
      type: String,
      default: 'Are you sure you want to log out?',
    },
    headerDescriptionText: {
      type: String,
      default: 'You will have to log back in later if you want to access your account details.',
    },
    logoutButtonText: {
      type: String,
      default: 'Log Out',
    },
    cancelButtonText: {
      type: String,
      default: 'Go Back',
    },
  },
  setup(_props, context) {
    const { logout, error } = useUser();
    const router = useRouter();
    const { clearCartLocalStorage } = useLocalStorageCart();

    const logoutError = error.value.logout;

    const logoutLoading = ref(false);

    const handleLogout = async () => {
      logoutLoading.value = true;
      try {
        await logout();
        clearCartLocalStorage();
        window.location.href = '/';
      } catch (error) {
        logoutLoading.value = false;
        console.error(error);
      }
    };

    const handleCancel = () => {
      context.emit('previous-tab');
      context.emit('close-logout-modal');
    };

    return {
      handleLogout,
      handleCancel,
      logoutLoading,
      logoutError,
    };
  },
});
